
import { Routes, Route } from "react-router-dom";
import Login from "../user/auth/Login";
import Register from "../user/auth/Register";
import Dashboard from "../user/dashboard/Dashboard";
import Layout from "../user/util/Navbar";
import Offers from "../user/offers/Offers";
import Reports from "../user/reports/Reports";
import Wallet from "../user/wallet/Wallet";
import Profile from "../user/profile/Profile";
import OfferDetailsPage from "../user/offers/OfferDetailsPage";
import ConversionLedgerPage from "../user/reports/ConversionLedgerPage";
import OfferGo from "../public/OfferGo";
import ReferPage from "../public/ReferPage";
import TrackPage from "../public/TrackPage";
import TrackReferPage from "../public/TrackReferPage";
import AdminLogin from "../admin/auth/AdminLogin";
import AdminDashboard from "../admin/dashboard/AdminDashboard";
import AdminNavbar from "../admin/utils/Navbar";
import AdminOffers from "../admin/offers/AdminOffers";
import AdminReports from "../admin/reports/AdminReports";
import AdminWithdraws from "../admin/withdraws/AdminWithdraws";
import AdminUsers from "../admin/users/AdminUsers";
import AdminSettings from "../admin/settings/AdminSettings";
import AdminLogs from "../admin/dashboard/AdminLogs";
import CustomDomain from "../user/cd/CustomDomain";
import ServicePausedPage from "../user/util/ServicePausedPage";
import NotFoundPage from "../util/NotFoundPage";
import AdminFirePostbackPage from "../admin/fire-postback/AdminFirePostbackPage";

function UserRoutes() {
  const hostname = window.location.hostname
    .toLowerCase()
    .replace(/\.$/, "");

  const isMainDomain =
    hostname === "earnmedia.co.in" ||
    hostname === "www.earnmedia.co.in" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1";

  // Custom domains can access only the tracking offer page.
  if (!isMainDomain) {
    return (
      <Routes>
        <Route path="/go/:trackId?" element={<OfferGo />} />
        <Route path="/refer/:trackId?" element={<ReferPage />} />
        <Route path="/track/:trackId?" element={<TrackPage />} />
        <Route path="/refer-track/:trackId?" element={<TrackReferPage />} />
        <Route
          path="*"
          element={<NotFoundPage/>}
        />
      </Routes>
    );
  }

  // Main EarnMedia website: preserve existing routes.
  return (
    <Routes>
      <Route path="/" element={<Layout><Dashboard /></Layout>} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/offers" element={<Layout><Offers /></Layout>} />
      <Route path="/offers/:offerId?" element={<Layout><OfferDetailsPage /></Layout>} />
      <Route path="/reports" element={<Layout><Reports /></Layout>} />
      <Route path="/reports/detailed/:offerId?" element={<Layout><ConversionLedgerPage /></Layout>} />
      <Route path="/wallet" element={<Layout><Wallet /></Layout>} />
      <Route path="/profile" element={<Layout><Profile /></Layout>} />
      <Route path="/custom/domain" element={<Layout><CustomDomain /></Layout>} />

      <Route path="/emAdmin7" element={<AdminNavbar><AdminDashboard /></AdminNavbar>} />
      <Route path="/emAdmin7/logs" element={<AdminNavbar><AdminLogs /></AdminNavbar>} />
      <Route path="/emAdmin7/login" element={<AdminLogin />} />
      <Route path="/emAdmin7/offers" element={<AdminNavbar><AdminOffers /></AdminNavbar>} />
      <Route path="/emAdmin7/fire-postback" element={<AdminNavbar><AdminFirePostbackPage /></AdminNavbar>} />
      <Route path="/emAdmin7/reports" element={<AdminNavbar><AdminReports /></AdminNavbar>} />
      <Route path="/emAdmin7/withdraws" element={<AdminNavbar><AdminWithdraws /></AdminNavbar>} />
      <Route path="/emAdmin7/users" element={<AdminNavbar><AdminUsers /></AdminNavbar>} />
      <Route path="/emAdmin7/settings" element={<AdminNavbar><AdminSettings /></AdminNavbar>} />

      <Route path="/go/:trackId?" element={<OfferGo />} />
      <Route path="/refer/:trackId?" element={<ServicePausedPage />} />
      <Route path="/track/:trackId?" element={<TrackPage />} />
      <Route path="/refer-track/:trackId?" element={<ServicePausedPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default UserRoutes;
